import { css } from '@emotion/css';

export const statsBlockWidth = css`
  min-width: 10rem;
`;

export const statsCardWidth = css`
  width: 30rem;
`;

export const popoverClasses = {
  paper: 'border border-divider rounded-8 shadow-03',
};

export const iconButtonContainer = css`
  width: 1.8rem;
  height: 1.8rem;
`;

export const inputStyles = css`
  input {
    line-height: normal;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;
